"use client";

/**
 * Microsoft Clarity consent helper.
 *
 * Kept out of microsoft_clarity.tsx so that module exports only the component -
 * mixing components and plain helpers in one file breaks Fast Refresh.
 */

type ClarityConsentValue = "granted" | "denied";

declare global {
	interface Window {
		clarity?: {
			(
				command: "consentv2",
				params: {
					ad_Storage: ClarityConsentValue;
					analytics_Storage: ClarityConsentValue;
				},
			): void;
			q?: unknown[][];
		};
	}
}

export function updateClarityConsent(granted: boolean) {
	if (typeof window === "undefined" || typeof window.clarity !== "function") {
		return;
	}

	const value: ClarityConsentValue = granted ? "granted" : "denied";
	window.clarity("consentv2", {
		ad_Storage: value,
		analytics_Storage: value,
	});
}
